import React from "react";

const Initials = ({ initial }) => {
  return (
    <div
      className="flex uppercase h-10 w-10 sm:h-14 sm:w-14 items-center justify-center rounded-xl 
                     bg-[#FFEFEB] border border-[#FFCCBF] text-[#FF6943] font-semibold"
    >
      {initial}
    </div>
  );
};

export default Initials;
